/** The areas the settings are grouped under, in the order shown. Any other category follows, A to Z. */
export const SETTING_CATEGORY_ORDER = ['Actions', 'Absence & safeguarding', 'Feedback', 'Reports', 'Accounts', 'Brand wording', 'Sessions'];

/** The LEAP brands a setting can be overridden for (FES 1, TP 2, PE 3). */
export const SETTING_BRANDS: { companyId: number; name: string }[] = [
  { companyId: 1, name: 'FES' },
  { companyId: 2, name: 'TP' },
  { companyId: 3, name: 'PE' }
];